export default {
    activeSidebar: 'addLead',
    bodyMarginTop: 0,
    bodyPaddingTop: 0,
    headerHeight: 0,
    navExpanded: false,
};
